import { render, staticRenderFns } from "./GuestForm.vue?vue&type=template&id=135d2b40&scoped=true"
import script from "./GuestForm.vue?vue&type=script&lang=js"
export * from "./GuestForm.vue?vue&type=script&lang=js"
import style0 from "./GuestForm.vue?vue&type=style&index=0&id=135d2b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d2b40",
  null
  
)

export default component.exports